import React from 'react';
import { Paper, Box, Typography, Chip, Stack } from '@mui/material';
import { WarningAmber } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { colors } from '@/theme/tokens';

/**
 * items: [{ label, count, display, severity: 'error'|'warning', href }]
 * `count` gates visibility (item hidden when count <= 0); `display` is the
 * text shown after the label (defaults to `count`, e.g. "Leaves to approve: 3"
 * — pass `display` to show a formatted value instead, e.g. "Fees pending: ₹12,400").
 * Renders nothing if there are no active (count > 0) items.
 */
export default function NeedsAttention({ items = [] }) {
  const navigate = useNavigate();
  const active = items.filter((i) => i.count > 0);
  if (active.length === 0) return null;

  return (
    <Paper elevation={0} sx={{ p: 2, mb: 3, border: '1px solid', borderColor: 'warning.light', bgcolor: '#FFFBEB' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
        <WarningAmber sx={{ color: colors.warning, fontSize: 20 }} />
        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Needs Attention</Typography>
      </Box>
      <Stack direction="row" spacing={1.5} flexWrap="wrap" useFlexGap>
        {active.map((i) => (
          <Chip
            key={i.label}
            label={`${i.label}: ${i.display ?? i.count}`}
            color={i.severity === 'error' ? 'error' : 'warning'}
            variant="outlined"
            onClick={i.href ? () => navigate(i.href) : undefined}
            sx={{ fontWeight: 600 }}
          />
        ))}
      </Stack>
    </Paper>
  );
}
